import React,{useState,useEffect} from "react";
import { useLocation, useParams } from "react-router-dom";
import { Table, Card,Button } from "react-bootstrap";
import { Modal, Alert } from "react-bootstrap";
import { useAuth } from "../Context/AuthContext";
import { toast } from "react-toastify";
import { createSettlement } from "../Api/Reconciliation";
import { useNavigate } from "react-router-dom";
import { getCustomerByIdAndOrg } from "../Api/Reconciliation";
const OpenInvoices = () => {
  const { customerCode } = useParams();
 const { user } = useAuth();
const location = useLocation();
const navigate = useNavigate();
const invoices = location.state?.invoices || [];
const statementAmount = location.state?.statementAmount || 0;
const statementId = location.state?.statementId || "";
const [selectedInvoices, setSelectedInvoices] = useState({});
const [remainingAmount, setRemainingAmount] = useState(
  Number(statementAmount)
);
const [showPostModal, setShowPostModal] = React.useState(false);
const [isSubmitting, setIsSubmitting] = React.useState(false);
const [customer, setCustomer] = useState(null);
const [loadingCustomer, setLoadingCustomer] = useState(false);

const [isOverAdjusted, setIsOverAdjusted] = useState(false);

const handleInvoiceToggle = (invoiceId, invoiceAmount) => {
  const isSelected = selectedInvoices[invoiceId];

  // UNSELECT
  if (isSelected) {
    setSelectedInvoices((prev) => {
      const updated = { ...prev };
      delete updated[invoiceId];
      return updated;
    });

    setRemainingAmount((prev) => prev + isSelected.allocatedAmount);
    setIsOverAdjusted(false);
    return;
  }

  // IF already over-adjusted → block further selections
  if (isOverAdjusted) {
    alert("Only one invoice can be selected when invoice exceeds statement amount.");
    return;
  }

  // CASE 1: Normal settlement
  if (remainingAmount >= invoiceAmount) {
    setSelectedInvoices((prev) => ({
      ...prev,
      [invoiceId]: {
        invoiceAmount,
        allocatedAmount: invoiceAmount,
      },
    }));

    setRemainingAmount((prev) => prev - invoiceAmount);
    return;
  }

  // CASE 2: Invoice > remaining (ALLOW ONLY ONCE)
  if (remainingAmount > 0 && Object.keys(selectedInvoices).length === 0) {
    setSelectedInvoices({
      [invoiceId]: {
        invoiceAmount,
        allocatedAmount: remainingAmount,
      },
    });

    setRemainingAmount(0);
    setIsOverAdjusted(true);
    return;
  }

  alert("Insufficient statement amount to select this invoice.");
};
const settlementPayload = {
  statementId,
  userId: user.userId,
  organizationId: user?.organisationId,
  invoices: Object.entries(selectedInvoices).map(
    ([invoiceId, data]) => ({
      invoiceId,
      allocatedAmount: data.allocatedAmount,
    })
  ),
};
useEffect(() => {
  if (!customerCode || !user?.organisationId) return;

  const fetchCustomer = async () => {
    try {
      setLoadingCustomer(true);
      const data = await getCustomerByIdAndOrg(
        customerCode,
        user.organisationId
      );
      setCustomer(data);
    } catch (err) {
      console.error("Failed to load customer data", err);
      toast.error("Failed to load customer details");
    } finally {
      setLoadingCustomer(false);
    }
  };

  fetchCustomer();
}, [customerCode, user?.organisationId]);

const isCheckboxDisabled = (invoiceId) => {
  if (selectedInvoices[invoiceId]) return false;

  if (isOverAdjusted) return true;

  return remainingAmount <= 0;
};


const handleAllocationChange = (invoiceId, newValue) => {
  const value = Number(newValue);

  if (isNaN(value) || value < 0) return;

  setSelectedInvoices((prev) => {
    const current = prev[invoiceId];
    if (!current) return prev;

    const maxAllowed = Math.min(
      current.invoiceAmount,
      remainingAmount + current.allocatedAmount
    );

    if (value > maxAllowed) {
      alert(`Maximum allowed allocation is ₹ ${maxAllowed}`);
      return prev;
    }

    const updated = {
      ...prev,
      [invoiceId]: {
        ...current,
        allocatedAmount: value,
      },
    };

    const totalAllocated = Object.values(updated).reduce(
      (sum, i) => sum + i.allocatedAmount,
      0
    );

    setRemainingAmount(Number(statementAmount) - totalAllocated);

    // over-adjusted flag logic
    setIsOverAdjusted(
      Object.keys(updated).length === 1 &&
        value < current.invoiceAmount
    );

    return updated;
  });
};

  return (
    <div className="container mt-4">
      <h4>Open Invoices – {customerCode}</h4>
      {customer && (
  <Card className="mb-3">
    <Card.Body>
      <div className="row">
        <div className="col-md-3">
          <strong>Customer Code</strong>
          <div>{customer.customerCode}</div>
        </div>

        <div className="col-md-5">
          <strong>Customer Name</strong>
          <div>{customer.name}</div>
        </div>

        <div className="col-md-2">
          <strong>Credit Limit</strong>
          <div>
            ₹ {Number(customer.creditLimit || 0).toLocaleString("en-IN")}
          </div>
        </div>

        <div className="col-md-2">
          <strong>Tax ID</strong>
          <div>{customer.taxId || customer.gstno || "-"}</div>
        </div>
      </div>
    </Card.Body>
  </Card>
)}

<Card className="mb-3">
  <Card.Body>
    <div className="d-flex justify-content-between mb-2">
      <strong>Statement Amount:</strong>
      <span>₹ {Number(statementAmount).toLocaleString("en-IN")}</span>
    </div>

    <div className="d-flex justify-content-between">
      <strong>Remaining Amount:</strong>
      <span
        className={
          remainingAmount === 0
            ? "text-success fw-bold"
            : "text-danger fw-bold"
        }
      >
        ₹ {remainingAmount.toLocaleString("en-IN")}
      </span>
    </div>
  </Card.Body>
</Card>


      <Table bordered hover>
        <thead>
          <tr>
            <th>Select</th>

            <th>#</th>
            <th>Invoice No</th>
            <th>Invoice Date</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {invoices.map((inv, index) => (
            <tr key={inv.invoiceId}>
                <td>
  <input
    type="checkbox"
    checked={!!selectedInvoices[inv.invoiceId]}
    disabled={isCheckboxDisabled(inv.invoiceId, inv.taxableValue)}
    onChange={() =>
      handleInvoiceToggle(inv.invoiceId, inv.taxableValue)
    }
  />
</td>

              <td>{index + 1}</td>
              <td>{inv.invoice?.invoiceNumber || "-"}</td>
              <td>
                {inv.invoice?.invoiceDate
                  ? new Date(inv.invoice.invoiceDate).toLocaleDateString()
                  : "-"}
              </td>
              <td>{inv.taxableValue}</td>
              <td>Open</td>
            </tr>
          ))}
        </tbody>
      </Table>
      
      {Object.keys(selectedInvoices).length > 0 && (
  <Card className="mt-4">
    <Card.Header>
      <strong>Selected Invoices</strong>
    </Card.Header>

    <Card.Body>
      <Table bordered size="sm">
        <thead>
          <tr>
            <th>Invoice ID</th>
            <th>Original Amount</th>
            <th>Allocated Amount</th>
            <th>Balance Amount</th>
          </tr>
        </thead>

        <tbody>
          {Object.entries(selectedInvoices).map(
            ([invoiceId, data]) => (
              <tr key={invoiceId}>
                <td>{invoiceId}</td>
                <td>
                  ₹ {data.invoiceAmount.toLocaleString("en-IN")}
                </td>
               <td>
  <input
    type="number"
    className="form-control form-control-sm"
    value={data.allocatedAmount}
    min={0}
    max={data.invoiceAmount}
    onChange={(e) =>
      handleAllocationChange(invoiceId, e.target.value)
    }
  />
</td>

                <td className="text-danger fw-bold">
                  ₹ {(data.invoiceAmount - data.allocatedAmount)
                    .toLocaleString("en-IN")}
                </td>
              </tr>
            )
          )}
        </tbody>
      </Table>
    </Card.Body>
  </Card>
)}
<Button
  variant="success"
  className="mt-3"
  disabled={Object.keys(selectedInvoices).length === 0}
  onClick={() => setShowPostModal(true)}
>
  Post Settlement
</Button>
<Modal
  show={showPostModal}
  onHide={() => setShowPostModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Posting</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p>Are you sure you want to post this settlement?</p>

    {remainingAmount > 0 && (
      <Alert variant="warning">
        Statement amount is still remaining:
        <strong>
          {" "}
          ₹ {remainingAmount.toLocaleString("en-IN")}
        </strong>
        <br />
        Please fully settle the statement before posting.
      </Alert>
    )}

    <div className="mt-3">
      <strong>Summary</strong>
      <ul className="mt-2">
        <li>Statement ID: {statementId}</li>
        <li>
          Total Allocated: ₹{" "}
          {(Number(statementAmount) - remainingAmount).toLocaleString("en-IN")}
        </li>
        <li>
          Invoices Selected: {Object.keys(selectedInvoices).length}
        </li>
      </ul>
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowPostModal(false)}
    >
      Cancel
    </Button>

    <Button
      variant="primary"
      disabled={remainingAmount > 0 || isSubmitting}
      onClick={async () => {
        setIsSubmitting(true);

        try {
  setIsSubmitting(true);

  await createSettlement(settlementPayload);

  toast.success("Statement posted successfully");
  navigate("/manual-Bank-reconciliation/:monthId?/:houseBankId?");
  setShowPostModal(false);

  // optional: redirect or reset state later
} catch (err) {
  console.error("Posting failed", err);
  toast.error("Failed to post settlement");
} finally {
  setIsSubmitting(false);
}

      }}
    >
      {isSubmitting ? "Posting..." : "Submit"}
    </Button>
  </Modal.Footer>
</Modal>

    </div>
  );
};

export default OpenInvoices;
